import type { VariantProps } from 'class-variance-authority'

import type { badgeVariants } from '@/shared/ui/badge'

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

// Operational instrument status codes that warrant an emphasized chip so a QC failure
// or maintenance state is obvious next to the (schedule-derived) task-status badge.
// Legacy parity (REBUILD-206, instruments.template.html:87 shows the chip for URDI/OFFL/MANT).
const ATTENTION_STATUS_CODES = new Set(['URDI', 'OFFL', 'MANT'])

// Chooses the Badge variant for the instrument's operational status chip: emphasized
// (warning) for attention states, neutral (secondary) otherwise.
export const instrumentStatusBadgeVariant = (
  statusCode: string | null | undefined,
): BadgeVariant => (statusCode && ATTENTION_STATUS_CODES.has(statusCode) ? 'warning' : 'secondary')
